import React from 'react';
import './Success.scss';
import Button from '../../button/Button';
import succes from '../../../assets/img/success.svg';

function Success({t,handlerSelectModal}) {
 
  return (
    <div className="success-wrapper">
        <div className="success-content">
            <div className="success-img">
              <img src={succes} alt="" />
            </div>
            <div className="success-capture">
              {t("succes-sent-1")}<br/>
              {t("succes-sent-2")}
            </div>
            <div className="success-button" >
              <Button text = {t("succes-button")} handlerSelectModal={handlerSelectModal}/>
            </div>
        </div>
    </div>
  );
}

export default Success;